import { styled } from "@mui/system";
import { Link } from "react-router-dom";

export const SubmitButton = styled("button")`
  width: auto;
  padding: 0.7rem 1.2rem;
  font-size: 1.3rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1.5rem;
  border-radius: 0.2rem;
  cursor: pointer;
  border: 1px solid transparent;
  text-decoration: none;
  margin: 0 0.8rem;
  font-family: "Roboto", sans-serif;
  min-width: 6.4rem;

  color: ${({ theme }) => theme.palette.white.main};
  background-color: ${({ theme }) => theme.palette.primary.main};

  &:disabled {
    background-color: ${({ theme }) => theme.palette.primary.light};
  }
  ${({ theme, customDisabled }) =>
    customDisabled &&
    `
    cursor: not-allowed;
    background-color: ${theme.palette.primary.light};
  `}
`;

export const CancelButton = styled(Link)`
  width: auto;
  padding: 0.75rem 1.2rem;
  font-size: 1.3rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1.5rem;
  border-radius: 0.2rem;
  cursor: pointer;
  border: 1px solid transparent;
  margin: 0 0.8rem;
  text-decoration: none;
  min-width: 6.4rem;
  font-family: "Roboto", sans-serif;
  border: 1px solid ${({ theme }) => theme.palette.border.light};
  color: ${({ theme }) => theme.palette.text.main};
  background-color: ${({ theme }) => theme.palette.white.main};
`;
